import React from "react";
import { Link } from "react-router-dom";
import localeText from "../../../../../../locale";

const ExtrapayBreadcrumb = ({ items }) => (
  <nav className="flex align-items-center gap-2 mb-3 text-sm flex-wrap" aria-label="Breadcrumb">
    {items.map((item, index) => (
      <React.Fragment key={`${item.labelKey}-${index}`}>
        {index > 0 && <span style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>/</span>}
        {item.to ? (
          <Link
            to={item.to}
            className="no-underline"
            style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
          >
            {localeText(item.labelKey)}
          </Link>
        ) : (
          <span style={{ color: "var(--theme-text, #344563)" }}>{localeText(item.labelKey)}</span>
        )}
      </React.Fragment>
    ))}
  </nav>
);

export default ExtrapayBreadcrumb;
